// Central product catalog for Balance. Prices are final (below-market).

export const IMG = {
  vialsHero: "/uploads/vials_hero.jpg",
  vial:
    "https://static.prod-images.emergentagent.com/jobs/cf4f5540-52da-46b8-a622-8ce8ae0e22ab/images/9b74a157f135202bf94409fff6b7f1f441dcde79afa33a05d532eaf04fc92f20.jpeg",
  kit:
    "/uploads/balance_kit_box.jpg",
  water:
    "https://static.prod-images.emergentagent.com/jobs/cf4f5540-52da-46b8-a622-8ce8ae0e22ab/images/7d522bcb3eebd06728b3fdad7ebe8a8cb2755721e5ee2219ab732e5b192ce35a.jpeg",
  modelDark:
    "https://images.pexels.com/photos/31579771/pexels-photo-31579771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
  modelCurly:
    "https://images.pexels.com/photos/6706877/pexels-photo-6706877.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
  modelTwo:
    "https://images.pexels.com/photos/15327096/pexels-photo-15327096.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
  modelEditorial:
    "https://images.pexels.com/photos/9097899/pexels-photo-9097899.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
  creamWhite:
    "https://images.pexels.com/photos/8015796/pexels-photo-8015796.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  creamDisplay:
    "https://images.pexels.com/photos/7691162/pexels-photo-7691162.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  dropper:
    "https://images.pexels.com/photos/8709583/pexels-photo-8709583.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  lotion:
    "https://images.pexels.com/photos/7303922/pexels-photo-7303922.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  pills1:
    "https://images.pexels.com/photos/12585202/pexels-photo-12585202.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  pills2:
    "https://images.pexels.com/photos/13105348/pexels-photo-13105348.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
};

export const PAYMENT = {
  venmo: "@Balance-beauty",
  chime: "$BalancePep",
  cashapp: "$thegeorgegroup",
  wholesaleEmail: "support@itsmybalance.com",
};

export const SHIPPING = 8.99;
export const FREE_SHIPPING_THRESHOLD = 200;

export const SKIN = [
  {
    id: "tret-0025",
    name: "Tretinoin 0.025%",
    sub: "Retinoid · 20g",
    price: 25,
    img: "/uploads/tretinoin_0025.jpg",
    desc: "Gentle first-step retinoid. Smooths texture, refines pores.",
    tag: "Beginner",
    accent: "#1f9e96",
  },
  {
    id: "tret-005",
    name: "Tretinoin 0.05%",
    sub: "Retinoid · 20g",
    price: 25,
    img: "/uploads/tretinoin_005.jpg",
    desc: "Mid-strength renewal for lines, marks and dullness.",
    tag: "Popular",
    accent: "#6a4c93",
  },
  {
    id: "tret-01",
    name: "Tretinoin 0.1%",
    sub: "Retinoid · 20g",
    price: 25,
    img: "/uploads/tretinoin_01.webp",
    desc: "Maximum strength resurfacing for experienced users.",
    tag: "Advanced",
    accent: "#b08a3e",
  },
  {
    id: "tret-bundle",
    name: "Tretinoin Trio",
    sub: "All 3 strengths · 60g",
    price: 59.99,
    compareAt: 75,
    img: "/uploads/tretinoin_trio.jpg",
    desc: "Every strength, one ritual. Bundle and save $15.",
    tag: "Best value",
    wide: true,
  },
  {
    id: "hydroquinone-4",
    name: "Hydroquinone 4%",
    sub: "Brightening · 20g",
    price: 24.99,
    img: "/uploads/hydroquinone.jpg",
    desc: "Clinical fade for stubborn hyperpigmentation & melasma.",
    tag: "Dark-spot hero",
  },
  {
    id: "skinshine",
    name: "Skinshine Cream",
    sub: "HQ 2% · Tret 0.025% · Mometasone 0.1%",
    price: 24.99,
    img: "/uploads/skinshine.webp",
    desc: "Triple-action melasma treatment in one tube.",
    tag: "Combo",
  },
  {
    id: "latanoprost",
    name: "Latanoprost 0.005%",
    sub: "Lash drops · 2.5mL",
    price: 29.99,
    img: "/uploads/latanoprost.jpg",
    desc: "Prostaglandin drop for longer, fuller lashes.",
  },
  {
    id: "azelaic",
    name: "Azelaic Acid 10%",
    sub: "Gel · 15g",
    price: 19.99,
    img: "/uploads/azelaic.jpg",
    desc: "Calms redness, clears breakouts, evens tone.",
  },
];

export const WELLNESS = [
  {
    id: "iverhuman",
    name: "Iverhuman 12mg",
    sub: "Ivermectin · 10 tablets",
    price: 15.99,
    img: "/uploads/iverhuman.jpg",
    desc: "Human-grade ivermectin, 12mg per tablet.",
  },
  {
    id: "mebentel",
    name: "Mebentel 100mg",
    sub: "Mebendazole · 10 tablets",
    price: 19.99,
    img: "/uploads/mebentel.jpg",
    desc: "Broad-spectrum antiparasitic support.",
  },
  {
    id: "ivrea",
    name: "Ivrea Lotion 1.0%",
    sub: "Ivermectin topical",
    price: 25.99,
    img: "/uploads/ivrea.jpg",
    desc: "Topical ivermectin lotion for skin.",
  },
  {
    id: "fenbendazole",
    name: "Fenbendazole 222mg",
    sub: "10 tablets",
    price: 19.99,
    img: "/uploads/fenbendazole.jpg",
    desc: "Wellness antiparasitic protocol staple.",
  },
  {
    id: "leucovorin",
    name: "Leucovorin Calcium",
    sub: "15mg · 10 tablets",
    price: 39.99,
    img: "/uploads/leucovorin.jpg",
    desc: "Folinic acid supplement.",
  },
];

// GLP-1 weight-management program — flat monthly, questionnaire-gated.
export const GLP1 = [
  {
    id: "sema-monthly",
    name: "Semaglutide",
    code: "S",
    overline: "GLP-1",
    price: 59,
    img: "/uploads/vial_s4.jpg",
    tagline: "Weekly GLP-1 support for appetite & steady weight management.",
    perks: [
      "$59 / month — flat at every dose",
      "Free shipping on every order",
      "Month-to-month · cancel anytime",
    ],
  },
  {
    id: "tirz-monthly",
    name: "Tirzepatide",
    code: "TR",
    overline: "GLP-1 / GIP",
    price: 99,
    img: "/uploads/vial_tr40.jpg",
    tagline: "Dual-action GLP-1 / GIP support for stronger appetite control.",
    perks: [
      "$99 / month — flat at every dose",
      "Free shipping on every order",
      "Month-to-month · cancel anytime",
    ],
  },
];

// Research vials. Vial + Kit (10 ct). Wholesale via email.
export const PEPTIDES = [
  { id: "reta-30", name: "RT30", mg: "30mg", price: 99, kit: 399, img: "/uploads/vial_reta30.jpg", desc: "Triple-agonist research compound.", popular: true },
  { id: "reta-15", name: "RT15", mg: "15mg", price: 69, kit: 299, img: "/uploads/vial_reta15.jpg", desc: "Triple-agonist research compound." },
  { id: "nad-500", name: "NAD+ 500mg", mg: "500mg", price: 25, kit: 198, img: "/uploads/vial_500.jpg", desc: "Cellular research compound." },
  { id: "ghkcu-100", name: "GHK-Cu 100mg", mg: "100mg", price: 25, kit: 98, img: "/uploads/vial_ghk.jpg", desc: "Copper peptide research compound." },
  { id: "bacwater-10", name: "Bacteriostatic Water 10mL", mg: "10mL", price: 12, kit: 35, img: "/uploads/water_10.jpg", desc: "Reconstitution fluid." },
  { id: "bacwater-3", name: "Bacteriostatic Water 3mL", mg: "3mL", price: 7, kit: 20, img: "/uploads/water_3.jpg", desc: "Reconstitution fluid." },
];

export const kitPrice = (vial) => Math.round(vial * 10 * 0.9 * 100) / 100;

// Refill loyalty promo — $10 off, auto-applied from reorder email link (?promo=REFILL10).
export const PROMO = { code: "REFILL10", amount: 10 };

// "Frequently added together" cart bundle (NAD+ + GHK-Cu at a small saving).
export const UPSELL_BUNDLE = {
  id: "nad-ghk-duo",
  name: "NAD+ & GHK-Cu Duo",
  ids: ["nad-500", "ghkcu-100"],
  price: 42,
  original: 50,
  img: "/uploads/vial_ghk.jpg",
  desc: "Cellular + copper-peptide research pair.",
};
